import React, { useState } from 'react';
import apiService from '../../services/api.service';
import './OrganizationIntake.css';

const OrganizationIntake = () => {
    const [formData, setFormData] = useState({
        name: '',
        adminUsername: ''
    });
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const response = await apiService.post('/organizations', formData);
            if (response.success) {
                setResult(response.data);
                setFormData({ name: '', adminUsername: '' });
            } else {
                setError(response.message || 'Failed to create organization');
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="intake-container">
            <div className="intake-header">
                <h1>Organization Intake</h1>
                <p>Create a new organization and initial admin user</p>
            </div>

            <div className="intake-content">
                <form className="intake-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Organization Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="e.g. Acme Corp"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="adminUsername">Admin Username</label>
                        <input
                            type="text"
                            id="adminUsername"
                            name="adminUsername"
                            value={formData.adminUsername}
                            onChange={handleChange}
                            placeholder="e.g. admin_acme"
                            required
                        />
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Creating...' : 'Create Organization'}
                    </button>
                </form>

                {error && <div className="intake-error">{error}</div>}

                {result && (
                    <div className="intake-success">
                        <h3>Success!</h3>
                        <p>Organization and admin user have been created.</p>
                        <div className="result-details">
                            <div className="result-row">
                                <span>Organization ID:</span>
                                <code className="code-font">{result.organizationId}</code>
                            </div>
                            <div className="result-row">
                                <span>Admin Username:</span>
                                <strong>{result.adminUsername}</strong>
                            </div>
                            <div className="result-row">
                                <span>Default Password:</span>
                                <code className="code-font">{result.defaultPassword}</code>
                            </div>
                        </div>
                        <div className="warning-note">
                            Please save these credentials. SSO setup will be available in a future update.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OrganizationIntake;
